import { restRequest } from "vrcore-dashboard/dist/utilities";
export const GET_FEATURES = restRequest("FEATURE.GET_FEATURES");
// export const GET_USERS = restRequest(
//     "COMPANY_ANALYTICS.GET_USERS"
// );
export const SET_REPORT_DETAILS = restRequest("VEHICLETEMPLATE.SET_REPORT_DETAILS");
export const GET_TEMPLATES = restRequest("VEHICLETEMPLATE.GET_TEMPLATES");
export const GET_ARCHIEVE_TEMPLATES = restRequest("VEHICLETEMPLATE.GET_ARCHIEVE_TEMPLATES");
export const SET_NEW_GROUP = restRequest("VEHICLETEMPLATE.SET_NEW_GROUP");
export const EDIT_GROUP = restRequest("VEHICLETEMPLATE.EDIT_GROUP");
export const REMOVE_GROUP = restRequest("VEHICLETEMPLATE.REMOVE_GROUP");
export const GET_INSPECTIONS = restRequest("VEHICLETEMPLATE.GET_INSPECTIONS");
export const REMOVE_TEMPLATE = restRequest("VEHICLETEMPLATE.REMOVE_TEMPLATE");
export const SET_NEW_ITEM = restRequest("VEHICLETEMPLATE.SET_NEW_ITEM");
export const EDIT_ITEM = restRequest("VEHICLETEMPLATE.EDIT_ITEM");
// export const ARCHIEVE_TEMPLATE = restRequest("VEHICLETEMPLATE.ARCHIEVE_TEMPLATE");
export const COPY_TEMPLATE = restRequest("VEHICLETEMPLATE.COPY_TEMPLATE");

